import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Blogs.css";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminButton, setShowAdminButton] = useState(false);

  const [newBlog, setNewBlog] = useState({
    title: "",
    date: "",
    description: "",
    content: ""
  });

  // ✅ Check admin
  useEffect(() => {
    const admin = localStorage.getItem("isAdmin");
    if (admin === "true") setIsAdmin(true);
  }, []);

  // ✅ Shortcut toggle
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "q") {
        setShowAdminButton((prev) => {
          if (prev) {
            localStorage.removeItem("isAdmin");
            setIsAdmin(false);
          }
          return !prev;
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // ✅ Fetch blogs
  useEffect(() => {
    axios.get("https://alrimal.net/blogs")
      .then(res => setBlogs(res.data))
      .catch(err => console.log(err));
  }, []);

  // ✅ Delete
  const handleDelete = (id) => {
    if (!window.confirm("Delete this blog?")) return;

    axios.delete(`https://alrimal.net/blogs/${id}`)
      .then(() => {
        setBlogs(blogs.filter(b => b.id !== id));
      })
      .catch(err => console.log(err));
  };

  // ✅ Add blog
  const handleAddBlog = () => {
    const formData = new FormData();

    formData.append("title", newBlog.title);
    formData.append("date", newBlog.date);
    formData.append("description", newBlog.description);
    formData.append("content", newBlog.content);

    if (imageFile) {
      formData.append("image", imageFile);
    }

    axios.post("https://alrimal.net/blogs", formData)
      .then(res => {
        setBlogs([res.data, ...blogs]);
        setNewBlog({ title: "", date: "", description: "", content: "" });
        setImageFile(null);
      })
      .catch(err => console.log(err));
  };

  return (
    <div className="blogPage container">

      <h2 className="blogHeading">Latest Blogs</h2>

      {/* 🔐 Admin */}
      {showAdminButton && (
        <div className="adminBar">
          {!isAdmin ? (
            <button
              className="primaryBtn"
              onClick={() => {
                const password = prompt("Enter admin password:");
                if (password === "232318") {
                  localStorage.setItem("isAdmin", "true");
                  setIsAdmin(true);
                } else {
                  alert("Wrong password");
                }
              }}
            >
              Admin Login
            </button>
          ) : (
            <button
              className="secondaryBtn"
              onClick={() => {
                localStorage.removeItem("isAdmin");
                setIsAdmin(false);
              }}
            >
              Logout
            </button>
          )}
        </div>
      )}

      {/* 🔥 Form */}
      {isAdmin && (
        <div className="adminForm">
          <input
            className="adminInput"
            placeholder="Title"
            value={newBlog.title}
            onChange={(e) =>
              setNewBlog({ ...newBlog, title: e.target.value })
            }
          />

          <input
            className="adminInput"
            placeholder="Date"
            value={newBlog.date}
            onChange={(e) =>
              setNewBlog({ ...newBlog, date: e.target.value })
            }
          />

          <input
            className="adminInput"
            type="file"
            onChange={(e) => setImageFile(e.target.files[0])}
          />

          <textarea
            className="adminTextarea"
            placeholder="Short Description"
            value={newBlog.description}
            onChange={(e) =>
              setNewBlog({ ...newBlog, description: e.target.value })
            }
          />

          <textarea
            className="adminTextarea"
            placeholder="Full Content"
            value={newBlog.content}
            onChange={(e) =>
              setNewBlog({ ...newBlog, content: e.target.value })
            }
          />

          <button className="primaryBtn" onClick={handleAddBlog}>
            Add Blog
          </button>
        </div>
      )}

      {/* 🔥 Blog Cards */}
      <div className="row">
        {blogs.map((blog) => (
          <div key={blog.id} className="col-lg-4 col-md-6">
            <div className="blogCard">

              <div className="blogImageWrapper">
                <img src={blog.image} alt="" className="blogImage" />
              </div>

              <div className="blogContent">
                <p className="blogDate">{blog.date}</p>
                <h5 className="blogTitle">{blog.title}</h5>
                <p className="blogDesc">{blog.description}</p>

                <Link to={`/blog/${blog.id}`} className="readMore">
                  Read More →
                </Link>

                {isAdmin && (
                  <button
                    onClick={() => handleDelete(blog.id)}
                    className="deleteBtn"
                  >
                    Delete
                  </button>
                )}
              </div>

            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Blogs;